






import { createComponent, ref } from "@vue/composition-api";
import DraftsList from "./DraftsList.vue";
import { Resource } from "@megarax/client/src";
import { useActions } from "@/shared/useMegaraxClient";
import { RevisionActions } from "@megarax/client/src/revision";
import { ResourceAppModule } from "../../shared/app";

interface Props {
  module: ResourceAppModule<RevisionActions<any, any>>;
}

export default createComponent<Props>({
  components: { DraftsList },
  props: {
    module: { required: true },
  },
  setup(props, ctx) {
    const items = ref<null | any[]>(null);

    useActions(props.module.resource)
      .fetchDrafts()
      .then((resp) => {
        items.value = resp.items;
      });

    return { items };
  },
});
